import { Signal } from "@lit-labs/signals";
import type { GetUnifiedLinksResult } from "api-contracts/rpc/get-unified-links";
import type { IBackofficeLinksState } from "./types";

export class BackofficeLinksState implements IBackofficeLinksState {
  readonly links = new Signal.State<GetUnifiedLinksResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
  readonly communityLinks = new Signal.State<GetUnifiedLinksResult | null>(null);
  readonly communityLinksLoading = new Signal.State<boolean>(false);
}
